"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("./styled.basicCard");

var _basicCardProps = require("./basicCardProps");

var _basicCardProps2 = _interopRequireDefault(_basicCardProps);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var BasicCard = function BasicCard(props) {
  var newProps = _extends({}, _basicCardProps2.default.props, props);
  var content = newProps.content,
      style = newProps.style,
      media = newProps.media,
      updateProps = newProps.updateProps,
      setData = newProps.setData,
      isEditMode = newProps.isEditMode,
      links = newProps.links;


  var imageProps = {
    imageRadius: getPropValue("text", "imageRadius", style.imageRadius, "style"),
    src: getPropValue("text", "imgUrl", media.imgUrl, "media"),
    alt: getPropValue("text", "alt", media.alt, "media")
  };

  var titleProps = {
    titleColor: getPropValue("text", "titleColor", style.titleColor, "style"),
    titleFontSize: getPropValue("text", "titleFontSize", style.titleFontSize, "style"),
    bottomSpace: getPropValue("text", "bottomSpace", style.bottomSpace, "style")
  };

  var columnPosition = {
    contentAlign: getPropValue("text", "contentAlign", style.contentAlign, "style")
  };

  var styledWrapperProps = {
    textFontSize: getPropValue("text", "textFontSize", style.textFontSize, "style"),
    textColor: getPropValue("text", "textColor", style.textColor, "style")
  };

  var title = getPropValue("text", "title", content.title, "content");
  var paragraph = getPropValue("text", "paragraph", content.paragraph, "content");

  var link1 = getPropValue("text", "link1", links.link1, "content");
  var url1 = getPropValue("text", "url1", links.url1, "content");

  var link2 = getPropValue("text", "link2", links.link2, "content");
  var url2 = getPropValue("text", "url2", links.url2, "content");

  var paragraphStyle = {
    contentSpace: getPropValue("text", "contentSpace", style.contentSpace, "style")
  };

  return _react2.default.createElement(
    _styled.StyledWrapper,
    styledWrapperProps,
    _react2.default.createElement(
      _reactBootstrap.Container,
      { className: "mb-4 BasicCard" },
      _react2.default.createElement(
        _styled.StyledRow,
        _extends({}, columnPosition, { className: "row" }),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: "6", className: "mb-4 mb-md-0" },
          _react2.default.createElement(_styled.Image, _extends({}, imageProps, { className: "w-100" }))
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: "6", className: style.contentAlign !== "center" ? "pt-4" : "" },
          _react2.default.createElement(
            _styled.Title,
            titleProps,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "title",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: title
            })
          ),
          _react2.default.createElement(
            _styled.Paragraph,
            paragraphStyle,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "paragraph",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: paragraph
            })
          )
        )
      )
    )
  );
};
exports.default = BasicCard;